style= require('./edit-match-source.styl')

.modal-header
  .modal-title='Override'
  ft-icon.close(name='ui--cross', (click)= this.parentNode.close())
if match
  .content
    .edit-time
      section
        label='Start Time'
        .time
          input(
            type="datetime-local",
            onfocus="this.showPicker()",
            [value]=match.startTime?.format('YYYY-MM-DDTHH:mm'),
            (input)=match.startTime=moment(e.target.value)
          )
      section
        label='End Time'
        .time
          input(
            onfocus="this.showPicker()",
            type="datetime-local",
            [value]=match.endTime?.format('YYYY-MM-DDTHH:mm'),
            (input)=match.endTime=moment(e.target.value)
          )
    .edit-main
      section
        label='Round'
        input(
          type='number',
          [value]=match.round || '',
          (input)=this.editTeam(match, 'round', e))
      if match.sport === 'golf'
        section
        label='UID'
        input(
          type='text',
          [value]=match.uid || uid || '',
          (input)=this.editTeam(match, 'uid', e))
      section
        label='External match page URL'
        input(
          type='text',
          [value]=match.externalMatchPageUrl || '',
          (input)=this.editTeam(match, 'externalMatchPageUrl', e))
      section
        label='Live stream URL'
        input(
          type='text',
          [value]=match.liveStreamUrl || '',
          (input)=this.editTeam(match, 'liveStreamUrl', e))
      section
        label='Live stream source'
        input(
          type='text',
          [value]=match.liveStreamSource || '',
          (input)=this.editTeam(match, 'liveStreamSource', e))
      each field in customFields
        section
          label= field.name || field.normal
          input(
            type=field.type,
            [value]=match[field.normal] || match[field.base] && match[field.base][field.index] || '',
            (input)=this.editTeam(match, field.normal, e))
      if season.league?.matchTypes
        section
          label='Type'
          select((change)=this.editTeam(match, 'matchType', e.target.value))
            for t in season.league.matchTypes
              option(
                value=t,
                selected= (t === match.matchType),
              )= t
      if match.playOffStage
        section
        label='Home score'
        input(
          type='number',
          [value]=match.score && match.score[0] || 0,
          (input)=this.editTeam(match, 'score1', e))
        label='Away score'
        input(
          type='number',
          [value]=match.score && match.score[1] || 0,
          (input)=this.editTeam(match, 'score2', e))
      if ['golf', 'rocket_runout'].includes(season.sport)
        section
        ft-toggle(
            checked=match.isSingleRound,
            (toggle)=this.toggleSingleRound(e)
          ) Single round
        section
        ft-toggle(
            checked=match.isSubMatch,
            (toggle)=this.toggleSubMatch(e)
          ) Sub match
      if season.isRacing
        section
        ft-toggle(
            checked=match.isSubMatch,
            (toggle)=this.toggleSubMatch(e)
          ) Sub match
        section
          label='Positions'
          select((change)=this.addPosition(e.target.value))
            option(disabled selected) --Pick a position--
            for p in this.positions
              option(
                value=p,
                selected= (this.selectedPositions && this.selectedPositions.includes(p))
                )= p
        section
          label='Selected Positions'
            for sp in this.selectedPositions
              .team((click)=this.removePosition(sp))= sp
    .edit-teams(class={extra: !match.isDuel || freeMode})
      ft-toggle(
        checked=freeMode,
        (toggle)=this.freeMode = !freeMode
      ) Free Mode
      if !match.isDuel || freeMode
        section
          label Teams
          select((change)=this.addTeam(e.target.value))
            option(disabled selected) --Pick a team--
            for team in sortedTeams
              option(
                value=team,
              )= team.name
          if !season.isDuel
            ft-button.add-all(
              success,
              (click)=this.addTeam('all')) Add All Teams
        section
          .overrides
            for team in this.editedTeams
              .team((click)=this.removeTeam(team))= team.name
      else
        each currentTeam, index in matchTeams
          section
            label=`Team ${index+1}`
            select((change)=this.changeTeam(e.target.value, index))
              option(disabled selected)='Select team'
              for team in sortedTeams
                option(
                  value=team,
                  selected=(currentTeam._id===team._id)
                )= team.name
.modal-footer
    ft-button.save(disabled = !similarTeams, (click)=this.closeModal())="Save"
